import axios from "axios";
import React, { createContext, useContext, useEffect, useState } from "react";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });
api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("el_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("el_token");
    if (!token) return setReady(true);
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => localStorage.removeItem("el_token"))
      .finally(() => setReady(true));
  }, []);

  const login = async (username, password) => {
    const { data } = await api.post("/auth/login", { username, password });
    localStorage.setItem("el_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("el_token");
    setUser(null);
  };

  return <AuthCtx.Provider value={{ user, setUser, login, logout, ready }}>{children}</AuthCtx.Provider>;
};

export const useAuth = () => useContext(AuthCtx);

export const homeFor = (role) =>
  ({ owner: "/owner", school_admin: "/school", teacher: "/teacher", student: "/student" }[role] || "/");
